import { TablePagination, TextField } from '@material-ui/core';
import Select from 'react-select';
import styled from 'styled-components';
import { StyledBox, StyledButton, StyledGrid } from 'styles/common';

import { getColorFromKey } from 'constants/helper';

export const ContentContainer = styled.div`
  background: ${(props) => (props.transparent ? 'none' : 'white')};
  width: calc(100% - 120px);
  margin-bottom: 2rem;
  border-radius: 5px;
`;

export const StyledTablePagination = styled(TablePagination)`
  margin: 0.5rem 1rem;
`;

export const StyledSelect = styled(Select)`
  .react-select__control {
    min-height: 40px;
  }
  width: ${(props) => (props.fullWidth ? '100%' : '85%')};
`;

export const BodyContainer = styled.div`
  height: 84vh;
  padding: 1rem 2rem;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0;
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  &::-webkit-scrollbar-thumb {
    background: #ff0000;
  }
`;

export const TemplateTextField = styled(TextField)``;

export const FullHeightBox = styled(StyledBox)`
  height: 100%;
`;

export const TemplateStyledButton = styled(StyledButton)`
  &:disabled {
    background-color: ${(props) => props.theme.palette.background.lightGrey3};
    color: ${getColorFromKey('textSecondary')};
    border: none;
  }
`;

export const WhiteBGStyledGrid = styled(StyledGrid)`
  background: white;
`;
